import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#0A1121\" fill-rule=\"evenodd\" d=\"M15 6h2V4h-2zM15 10h2V8h-2zM7 6h2V4H7zM7 10h2V8H7zM11 6h2V4h-2zM11 10h2V8h-2zM15 14h2v-2h-2zM7 14h2v-2H7zM11 14h2v-2h-2z\" clip-rule=\"evenodd\"></path><mask id=\"a\" width=\"18\" height=\"20\" x=\"3\" y=\"2\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:luminance;\"><path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M21 12v10H3V2h18z\" clip-rule=\"evenodd\"></path></mask><g mask=\"url(#a)\"><path fill=\"#0A1121\" fill-rule=\"evenodd\" d=\"M14 21v-4c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v4H6V3h12v18zm6.5 0H19V2.5c0-.3-.2-.5-.5-.5h-13c-.3 0-.5.2-.5.5V21H3.5c-.3 0-.5.2-.5.5s.2.5.5.5h17c.3 0 .5-.2.5-.5s-.2-.5-.5-.5\" clip-rule=\"evenodd\"></path></g>", 3)
  ]))]))
}
export default { render: render }